import { Link, useLocation, useNavigate } from 'react-router';
import { ErrorPage, type ErrorPageLinkProps } from '@zagru/design-system';
import { useT } from '@zagru/platform';

/** Link actions render through the router, so a middle-click opens a tab and a click stays in the SPA. */
export function renderErrorPageLink({ href, children, ...props }: ErrorPageLinkProps) {
  return (
    <Link to={href} {...props}>
      {children}
    </Link>
  );
}

/** 404 page rendered for unknown routes inside the shell. */
export function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const t = useT();
  return (
    <ErrorPage
      variant="404"
      title={t('shell.error.notFound.title')}
      description={t('shell.error.notFound.description')}
      primaryAction={{ label: t('shell.error.goHome'), href: '/today' }}
      secondaryAction={{ label: t('shell.error.goBack'), onClick: () => navigate(-1) }}
      technicalLabel={t('failure.technicalDetails')}
      technical={<code className="code">{pathname}</code>}
      renderLink={renderErrorPageLink}
    />
  );
}
